import React, {Component} from 'react';
import {BeatLoader} from 'react-spinners';
import {Link} from 'react-router-dom';
import moment from  'moment';
import NotificationSystem from 'react-notification-system';
import Modal from 'react-modal';
import Datetime from 'react-datetime';
import {_addNotification, _addNotificationError,isRegularLunchOrderType} from "../../../../server/util";
import { get,postWithHeadersResponse,postWithHeaders } from '../../../../server/actions'
import DateTimeRangePicker from '../../../Misc/DateTimeRangePicker'
import {HorizontalBar} from 'react-chartjs-2';
import {MenuOrderTypes,MealTypesReports } from '../../../../server/constants';
import {getReportMenuOptions} from '../../../Misc/MenuOptions/menuOptionsActions';
var _ = require('lodash');
const options={
    responsive: true,
    maintainAspectRatio: false,
    scales: {
        yAxes: [{
                ticks: {
                 fontSize: 9,
                min:0                
            }
               }],
        xAxes: [{
                ticks: {
                 fontSize: 9,
                 min:0
                }
               }]
             },
             plugins: {
               datalabels: {
                  display: true,
                  color: 'white',
                  font: { size: '10' },
               }
            }
}
  
class ItemHBar extends Component {
    constructor(props){
        super(props);
        this.state={
            loading:false,
            selectedDates:{
                startDate:moment(moment((this.props.activeMonth||moment()),'YYYYMM')).startOf('month'),
                endDate:moment(moment((this.props.activeMonth||moment()),'YYYYMM')).endOf('month')
            },
            mealType:(getReportMenuOptions()[0]||''),
            activeMonth:null,
            chartObj:{
                labels: [],
                datasets: [
                  {
                    label: 'Ordered count',
                    backgroundColor: 'rgba(244, 126, 53, 1)',
                    borderColor: 'rgba(244, 126, 53, 1)',
                    borderWidth: 1,
                    hoverBackgroundColor: 'rgba(244, 126, 53, 1)',
                    hoverBorderColor: 'rgba(244, 126, 53, 1)',
                    data: []
                  }
                ]
              }
        }
        this.init=this.init.bind(this)
        this.onChangeDateRange=this.onChangeDateRange.bind(this);
        this.getData=this.getData.bind(this);
    }
    componentWillMount=()=>{
        this.init();

    }
    init=()=>{
        this.onChangeDateRange(
            moment((this.props.activeMonth||moment()),'YYYYMM').startOf('month')
            ,moment((this.props.activeMonth||moment()),'YYYYMM').endOf('month'));
    }
    onChangeDateRange=(startDate,endDate)=>{
        let _selectedDate={startDate:startDate,endDate:endDate}
        this.setState({selectedDates:_selectedDate},()=>{
            this.getData(startDate,endDate)
        })            
        
    }
    componentWillReceiveProps=(nextProps)=> {
        if(this.state.activeMonth!==nextProps.activeMonth){
            let _selectedDate={
                startDate:moment((nextProps.activeMonth||moment()),'YYYYMM').startOf('month'),
                endDate:moment((nextProps.activeMonth||moment()),'YYYYMM').endOf('month')
            }
        this.setState({selectedDates:_selectedDate}
            ,this.getData(_selectedDate.startDate,_selectedDate.endDate))                
        }
    }
    getData=(startDate,endDate)=>{
        let dateStart = moment(startDate).format('YYYY-MM-DD');
        let dateEnd = moment(endDate).format('YYYY-MM-DD');
        if(this.state.mealType===MealTypesReports.LUNCH ||
            this.state.mealType===MealTypesReports.SNACK){
        //const mType=(this.state.mealType===MealTypesReports.LUNCH) &&!isRegularLunchOrderType()?MenuOrderTypes.ITEMIZE:this.state.mealType;      
        get('/dashboard/nMostOrderedItems?mealSchoolId=' + sessionStorage.getItem('SchoolId')+ '&menuType='+ this.state.mealType + '&startDate=' + dateStart + '&endDate=' + dateEnd + '&requiredTopItems=5&access_token=').then((response) => {
            this.setState({loading: true})
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(respData => {
            console.log('data', respData);
            let orders = respData || {};
            let _chartObj=this.state.chartObj;
            let _chartObjList=[];
            _chartObj.labels=[];
            _chartObj.datasets[0].data=[];
            Object.keys(orders).map((key)=>{
                _chartObjList.push({itemName:key, count:orders[key]})
            })
           let _chartObjListSorted= _.orderBy(_chartObjList, ['count'],['desc']);
            _chartObjListSorted.map((item)=>{
                _chartObj.labels.push(item.itemName);
                _chartObj.datasets[0].data.push(item.count);
            })
            
            this.setState({ lineChart:_chartObj,loading: false          
            })            
        }).catch(
            (error) => {
                this.setState({loading: false})
                console.log('Get School data response', error)
            }
        );
    }
    }
    render(){
        return(<div>
         <NotificationSystem ref="notificationSystem"/> 
         <div className="col-md-4"> 
         <div className='sweet-loading'
                     style={{position: 'absolute', top: '50%', left: '48%', zIndex: '1000'}}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>        
         <div className="panel chart-panel">
            <div className="panel-heading text-center" style={{padding:'0px'}}>
                <span className="panel-title" style={{fontSize: '14px', fontWeight:'600'}}>Most Ordered Items</span>
                <div className="pull-right">
                <DateTimeRangePicker startDate={this.state.selectedDates.startDate} endDate={this.state.selectedDates.endDate} applyCallback={(event,picker)=>{this.onChangeDateRange(picker.startDate,picker.endDate)}} isDateShow={false} />
                </div>
                <p style={{fontSize: '12px', fontWeight:'600'}}>{'Date Range: '+moment(this.state.selectedDates.startDate).format('DD-MMM-YYYY')+' to '+moment(this.state.selectedDates.endDate).format('DD-MMM-YYYY')}</p>
            </div>
            <div className="panel-body" style={{padding:'0px'}}>        
            <HorizontalBar data={this.state.chartObj} options={options} />
            </div>
            </div>
        </div>
        </div>)
    }
}
export default ItemHBar


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Home/DashboardCharts/ItemHBar.jsx